<section class="titleS">
    <h1>Ienupari</h1>
</section>

<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/ienupar/blue-arrow.jpg" class="img-fluid" alt="blue-arrow">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Ienupar</h1>
                                <p>Blue Arrow</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Blue Arrow este un ienupar suplu si zvelt, cu crestere verticala si coroana ingusta, cu
                            ramurile lungi, indreptate in sus. Culoarea acelor oscileaza de la albastru-verzui la
                            albastru-argintiu. Crestere rapida si isi pastreaza forma chiar si fara taiere. Emana un
                            miros placut, in special la atingere. Ienuparii tolereaza orice sol, cu exceptia celor unde
                            balteste apa. Se dezvolta cel mai bine in locuri insorite sau usor umbrite. Odata stabilit,
                            tolereaza seceta pe termen lung si vanturile puternice. Tunderea nu este necesara, dar se
                            poate face primavara inainte de incoltire sau spre sfarsitul verii. Complet rezistent pana
                            la -40 grade Celsius.</p>
                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Juniperus</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Blue Arrow</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>80-100</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>500-700</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>40</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>Soare, semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr>

<!-- <section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/ienupar/spartan.jpg" class="img-fluid" alt="tuja">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Ienupar</h1>
                                <p>Spartan</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Crestere rapida si isi pastreaza forma chiar si fara tundere.</p>
                        <p>Ienuperii tolereaza orice sol, cu exceptia celor unde balteste apa. Se dezvolta cel mai bine
                            în locuri insorite sau usor umbrite. Odata stabilit, tolereaza seceta pe termen lung si
                            vanturile puternice. Tunderea nu este necesară dar se poate face primavara inainte de
                            a intra in vegetatie sau spre sfarsitul verii. Complet rezistent pana la -40 grade Celsius.
                        </p>


                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Juniperus</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Spartan</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>80-100</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>500-700</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>40</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>Soare, semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr> -->
<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/ienupar/princeofwalles1.jpg" class="img-fluid" alt="princeofwalles1">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Ienupar</h1>
                                <p>Prince of Walles</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Imprastiat ca un covor de frunzis luxuriant, verde stralucitor, in forma de stea. In toamna
                            si iarna isi schimba culoarea in nuanta prunei.</p>
                        <p>Daunatorii ocazionali de insecte includ afide, viermi. Aveti grija la acarienii, paianjen.
                            Frunzele plantelor mature vor muri uneori in centru.</p>


                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Juniperus</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Prince of Walles</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>D 40</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>Intindere 100-200</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>40</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>Soare, semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr>
<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/ienupar/stricta.jpg" class="img-fluid" alt="princeofwalles1">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Ienupar</h1>
                                <p>Stricta</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Conifer pitic originar din Asia. Prezinta un port dens si conic.Frunzis verde-albastrui in
                            perioada primavara-vara iar toamna si iarna prezinta o usoara nuanta de mov</p>



                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Juniperus</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Stricta</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>incepand cu: 50</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>100-200</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>incepand cu: 50</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>Soare, semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr>
<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/ienupar/variegata.jpg" class="img-fluid" alt="princeofwalles1">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Ienupar</h1>
                                <p>Variegata</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Acest conifer prezinta frunzisul vesnic verde. Frunzele sunt sub forma de ace si au o nuanta
                            de verde intunecat. Este originar din zona Europei centrala si sud din zonele muntoase. </p>
                        <p>Nu atrage insecte daunatoare si nu este sensibil la boli.</p>



                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Juniperus</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Variegata</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>incepand cu: 30</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>100-150</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>incepand cu: 50</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>Soare, semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr>
<section class="sec">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/ienupar/virginiana.jpg" class="img-fluid" alt="princeofwalles1">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Ienupar</h1>
                                <p>Virginiana</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Conifer de talie medie compact ce poate atinge la maturitate o inaltime de 80 - 100 cm si un
                            diametru de 200-250cm. Ramurile sunt lungi, spre varf usor pendente. Culoarea foliajului
                            este gri-argintiu iar textura acelor este moale.</p>



                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Juniperus</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Virginiana</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>incepand cu: 50</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>h:80-100 D: 200-250cm</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>incepand cu: 50</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>Soare, semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr>




<section class="sec" id="ultim">

    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/ienupar/pingii-loderi.jpg" class="img-fluid" alt="tuja">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Ienupar</h1>
                                <p>Pingii-loderi</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Acest soi de ienupar se poate planta si pastra si in ghivece fiind ideal pentru gradinile
                            mici unde spatiul este limitat deoarece formeaza un decor pe masura. Poate fi plantat si in
                            parcuri si spatii verzi publice. Arata uimitor mai ales in aranjamentele de stancarii si in
                            gradinile alpine.</p>
                        <p>Frunzisul ienuparului Pingii Loderi este intr-o nuanta argintie-verzuie. Rezista foarte bine
                            la orice conditii de mediu si poate fi plantat si in soluri nisipoase cu umiditate medie sau
                            uscate.</p>
                        <p>Poate atinge la maturitate inaltimea maxima de 150 cm . Indrageste locurile cu soare din
                            abundenta, in care isi pastreaza
                            culoarea vie si vibranta.</p>

                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Juniperus</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Pingii-loderi</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>50-70</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>150</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>incepand cu 50</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>Soare, semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>

</section>
<hr>